import React from 'react';
import HeroSlider from './HeroSlider';

const Hero = () => {
  return <HeroSlider />;
};

export default Hero;
